import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';

@Component({
  selector: 'app-change-pass',
  templateUrl: './change-pass.page.html',
  styleUrls: ['./change-pass.page.scss']
})
export class ChangePassPage implements OnInit {

  passwordType1 = 'password';
  passwordType2 = 'password';
  iconType1 = 'eye';
  iconType2 = 'eye';
  shown1 = false;
  shown2 = false;

  en_changePassword = 'Change Your Password';
  en_resetButton = 'Reset Password';

  sp_changePassword = 'Cambia tu Contraseña';
  sp_resetButton = 'Reestablecer';

  language: string;

  constructor(private _viewCtrl: ModalController, private _params: NavParams) {
  }

  async ngOnInit() {
    this.language = this._params.get('language');
    this.didEnter();
  }

  didEnter() {
    const text = document.getElementsByClassName('to_hide_text') as HTMLCollectionOf<HTMLElement>;
    for (let i = 0; i < text.length; i++) { text[i].classList.add('anim'); }
  }

  goBack() {
    this._viewCtrl.dismiss();
  }

}
